import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import BikeCard from "@/components/site/BikeCard";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import { MaskedLine, Reveal } from "@/components/site/Reveal";
import { api } from "@/api";

const filters = [
  { key: "all", label: "All" },
  { key: "Bike", label: "Bikes" },
  { key: "Scooter", label: "Scooters" },
  { key: "featured", label: "Featured" },
];

const Inventory = () => {
  const [bikes, setBikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/bikes")
      .then(({ data }) => setBikes(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const visible = useMemo(() => {
    if (filter === "all") return bikes;
    if (filter === "featured") return bikes.filter((b) => b.featured);
    return bikes.filter((b) => b.category === filter);
  }, [bikes, filter]);

  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="inventory-page">
      <Nav />
      <WhatsAppFloat />

      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-32 md:pt-40 pb-10">
        <p className="text-volt uppercase tracking-[0.3em] text-xs font-semibold mb-4">Live Stock</p>
        <h1 className="font-display font-semibold uppercase tracking-tighter leading-[0.95] text-5xl md:text-7xl" data-testid="inventory-heading">
          <MaskedLine delay={0.1}>The</MaskedLine>
          <MaskedLine delay={0.25} className="text-outline">Inventory</MaskedLine>
        </h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="mt-5 max-w-lg text-white/60 leading-relaxed"
        >
          Har bike verified, har price fair. Pasand aaye toh seedha WhatsApp par baat karo.
        </motion.p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-24">
        <Reveal className="flex flex-wrap gap-3 mb-10" data-testid="inventory-filters">
          {filters.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`filter-${f.key}`}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold uppercase tracking-widest border transition-colors duration-300 ${
                filter === f.key
                  ? "bg-volt text-black border-volt"
                  : "border-white/20 text-white/60 hover:border-volt hover:text-volt"
              }`}
            >
              {f.label}
            </button>
          ))}
        </Reveal>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[0, 1, 2].map((i) => (
              <div key={i} className="border border-white/10 bg-card animate-pulse aspect-[3/4]" />
            ))}
          </div>
        ) : visible.length === 0 ? (
          <div className="border border-white/10 bg-card p-16 text-center" data-testid="inventory-empty">
            <p className="font-display font-semibold uppercase tracking-tight text-2xl text-white/70">Abhi stock khatam hai</p>
            <p className="mt-2 text-white/40 text-sm">Nayi bikes jald aa rahi hain. WhatsApp par poochho!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="inventory-grid">
            {visible.map((bike, i) => (
              <BikeCard key={bike.id} bike={bike} index={i} />
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default Inventory;
